<app-pageheader [Parent]="this">
</app-pageheader>
  
<app-datalistview [Columns]="Columns" [ShowMap]="true" ApiUrl="infrastructure/gatewayconfigurations/searches"
[AllowEdit]="true" EditUrl="/hardware/devices/gateways/:id" [StructureViewerLayers]="StructureViewerLayers" StructureViewerForType="GatewayConfiguration">
    <app-filter-set>
        <div app-search-filter></div>
        <div app-search-button></div>
    </app-filter-set>
</app-datalistview>